import React from "react";
import { Search, FileCheck, ShoppingBag } from "lucide-react";

const HowItWorks = () => {
  const steps = [
    {
      number: "01",
      icon: Search,
      title: "Learn About Products",
      description: "Browse our catalog and review detailed ingredient information for each product."
    },
    {
      number: "02",
      icon: FileCheck,
      title: "Review Details & Policies",
      description: "Check product directions, warnings, and our clear refund and shipping policies."
    },
    {
      number: "03",
      icon: ShoppingBag,
      title: "Choose What Fits Your Routine",
      description: "Select products from the catalog that align with your med spa, aesthetic, or wellness research focus."
    }
  ];

  return (
    <section className="py-24 bg-white">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-16">
          <h2 className="text-3xl md:text-4xl font-bold text-[#3a2a26] mb-4">
            How It Works
          </h2>
          <p className="text-[#7a6b62] max-w-2xl mx-auto">
            Simple, transparent shopping in three steps
          </p>
        </div>

        <div className="grid md:grid-cols-3 gap-8">
          {steps.map((step, index) => (
            <div key={step.number} className="relative">
              {/* Connector Line */}
              {index < steps.length - 1 && (
                <div className="hidden md:block absolute top-16 left-1/2 w-full h-0.5 bg-gradient-to-r from-[#d4a5ad]/50 to-transparent" />
              )}

              <div className="bg-[#fffaf5] border border-[#f0d8d4] rounded-2xl p-8 text-center relative z-10">
                {/* Step Number */}
                <div className="absolute -top-4 left-1/2 -translate-x-1/2">
                  <span className="bg-[#d4a5ad] text-white text-sm font-bold px-4 py-1 rounded-full">
                    Step {step.number}
                  </span>
                </div>

                <div className="w-16 h-16 bg-[#fdf2f4] rounded-2xl flex items-center justify-center mx-auto mb-6 mt-4">
                  <step.icon className="w-8 h-8 text-[#b89a6d]" />
                </div>

                <h3 className="text-xl font-bold text-[#3a2a26] mb-3">{step.title}</h3>
                <p className="text-[#7a6b62]">{step.description}</p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default HowItWorks;
